import { z } from "zod";

export const updateICafePayloadSchema = z.object({
  companyID: z.string(),
  franchiseCode: z.number(),
  lineCompanyCode: z.number(),
  lineGoodsCode: z.number(),
  phoneNumber: z.string(),
  postZipCode: z.string(),
  postBasicAddress: z.string(),
  postDetailAddress: z.string(),
  mngAppCode: z.number(),
  pcCnt: z.number(),
  hardwareID_CPU: z.string(),
  hardwareID_GraphicChipset: z.string(),
  hardwareID_HDD: z.string(),
  hardwareID_RAM: z.string(),
  osCode: z.number(),
  managerMobilePhoneNumber: z.string(),
  managerMobileMarketingPolicyAgree: z.boolean(),
});

export type UpdateICafePayloadType = z.infer<typeof updateICafePayloadSchema>;
